import { apiFetch } from "../utils/apiFetch"

export type InboxMessage = {
  id: string
  title: string
  body: string
  link: string | null
  read: boolean
  createdAt: string
}

export function getMessages() {
  return apiFetch("/api/messages") as Promise<{ messages: InboxMessage[] }>
}

export function getUnreadCount() {
  return apiFetch("/api/messages/unread-count") as Promise<{ unread: number }>
}

export function markMessageRead(id: string) {
  return apiFetch(`/api/messages/${encodeURIComponent(id)}/read`, { method: "POST" })
}

export function markAllMessagesRead() {
  return apiFetch("/api/messages/read-all", { method: "POST" })
}

export function deleteMessage(id: string) {
  return apiFetch(`/api/messages/${encodeURIComponent(id)}`, { method: "DELETE" })
}
